<p-tabs scrollable value="0" (onChange)="onTabChange($event)">
  <p-tablist>
    <p-tab value="0">Incentive Count</p-tab>
    <p-tab value="1">Deal Association Document</p-tab>
    <p-tab value="2">Exception/Dispute Requests</p-tab>
    <p-tab value="3">All Incentives</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="0">
      @if (isEngagmentCountSelected) {
        <app-incentive-count></app-incentive-count>
      }
    </p-tabpanel>
    <p-tabpanel value="1">
      <app-deal-association-document-queue></app-deal-association-document-queue>
    </p-tabpanel>
    <p-tabpanel value="2">
      <app-exception-dispute-requests></app-exception-dispute-requests>
    </p-tabpanel>
    <p-tabpanel value="3">
      <app-all-incentives></app-all-incentives>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
